<template>
  <section class="activity">
    <span
      class="total"
      :class="{hidden:!activityCount}"
    >{{$t('global.共x篇文章',{count:activityCount})}}</span>
    <div class="content">
      <div class="left">
        <div class="empty" v-if="activityCount === 0 && !loading">
          <img src="/static/v2/match/article_empty.png" alt />
          <p>{{$t('global.该频道还没有相关文章')}}</p>
        </div>
        <ul class="activity-list" v-else>
          <li v-for="item in activityList" :key="item.id">
            <ActivityCard :item="item" :topicId="topicId" />
          </li>
        </ul>
        <Loading v-if="loading" />
        <Reload v-if="loadError" @callback="loadMore" />
        <no-more v-if="!hasNextPage && activityList.length" />
      </div>
      <div class="right">
        <div class="box" :class="{empty:!count}">
          <ul v-if="userList.length">
            <li v-for="item in userList" :key="item.id" :class="{'userType2':item.userType === 2 && item.isCertification === 1}">
              <img :src="item.avatar| imageUrl('/static/profile_img_default.png',100,100)" alt :title="item.nickName" />
            </li>
          </ul>
          <p v-if="count">{{$t('global.共有x个成员于此频道发布文章',{count:count})}}</p>
          <p v-else>{{$t('global.还没有成员于此频道发布文章')}}</p>
          <span class="button" @click="navTo">
            <img src="/static/v2/match/article_write_icon.png" alt />
            写文章
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ActivityCard from "@/components/v2/match/activityCard.vue";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  components: { ActivityCard, Reload, Loading, NoMore },
  data() {
    return {
      userList: [],
      count: 0,
      topicId: null,
      activityList: [],
      loading: false,
      hasMore: true,
      loadError: false,
      hasNextPage: true,
      pageIndex: 1,
      pageSize: 20,
      activityCount: null
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    init() {
      this.topicId = this.$route.params.id;
      this.getActivityList();
      this.getMember();
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 20) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getActivityList();
        }
      }
    },
    getActivityList() {
      this.loading = true;
      const url = "/api/2.0/topic/findArticleList";
      const params = {
        topicId: this.topicId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          this.activityList = [...this.activityList, ...res.data.list];
          this.activityCount = res.data.totalRecord;
          this.hasNextPage = res.data.hasNextPage;
        } else {
          this.pageIndex--;
          this.loadError = true;
        }
      });
    },
    getMember() {
      const url = `/api/2.0/topic/findArticleCreaterList`;
      const params = {
        topicId: this.topicId,
        pageIndex: 1,
        pageSize: 5
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.userList = res.data.list || [];
          this.count = res.data.totalRecord;
        }
      });
    },
    navTo() {
      this.$router.push(`/article/edit?topicId=${this.topicId}`);
    }
  }
};
</script>

<style lang="stylus" scoped>
.activity {
  .total {
    display: block;
    color: #999999;
    font-size: 15px;
    font-weight: 500;
    padding: 30px 0;

    &.hidden {
      visibility: hidden;
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    padding-bottom: 40px;

    .left {
      width: 730px;

      .empty {
        text-align: center;

        img {
          width: 88px;
          height: 88px;
        }

        p {
          font-size: 15px;
          padding-top: 30px;
          color: #B8B8B8;
        }
      }

      .activity-list {
        padding-bottom: 40px;

        li {
          border-bottom: 1px solid #EBEBEB;
          margin-bottom: 25px;
          padding: 0 0 20px;

          &:last-child {
            border: none;
          }
        }
      }
    }

    .right {
      flex: 1;
      align-self: flex-start;

      .box {
        width: 285px;
        height: 220px;
        background: #fff;
        border: 1px solid #EBEBEB;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        font-family: PingFangSC-Regular, PingFang SC;
        margin: 0 auto;

        &.empty {
          height: 150px;
        }

        ul {
          display: flex;
          flex-direction: row;
          height: 50px;
          padding-bottom: 20px;

          li {
            width: 40px;
            position: relative;
            margin-left: -5px;

            &.userType2::before {
              content: '';
              right: -10px;
              bottom: 2px;
              position: absolute;
              width: 16px;
              height: 16px;
              background: url('/static/v2/match/Verified_icon_blue_20.png');
              background-size: 16px;
            }

            img {
              width: 48px;
              height: 48px;
              border-radius: 100%;
              border: 2px solid #fff;
            }
          }
        }

        p {
          font-size: 14px;
          color: #999;
          padding-bottom: 30px;
        }

        .button {
          display: inline-block;
          background: #2026CC;
          height: 40px;
          width: 170px;
          color: #fff;
          font-size: 16px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;

          &:hover {
            background: #1C21B0;
          }

          img {
            width: 20px;
            height: 20px;
            vertical-align: text-top;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/channel/Activity.vue